import * as React from 'react';
import { Label } from 'components/src/typography';
import { clsx } from 'clsx';

type Props = {
  step: number;
  currentStep: number;
};

const renderLine = (answered: boolean) => {
  return (
    <div
      className={`m-auto h-2 w-24 rotate-180 transition-colors ease-linear first:hidden last:hidden lg:h-24 lg:w-2 ${clsx(
        {
          'bg-red-100': answered,
          'bg-black-25': !answered,
        }
      )}`}
    />
  );
};

const Stepper = ({ step, currentStep }: Props) => {
  const answered = step <= currentStep;
  const isActive = step === currentStep;
  return (
    <>
      {renderLine(answered)}
      <div
        className={`flex h-32 w-32 justify-center rounded-full transition-all ease-linear ${clsx({
          'border-2 border-red-100 bg-white-100': isActive,
          'bg-red-100': answered,
          'border-white-100 bg-black-25': !answered,
        })}`}
      >
        <div
          className={`flex h-24 w-24 justify-center self-center rounded-full transition-colors ease-linear ${clsx({
            'bg-black-25': !answered,
            'bg-red-100': answered,
          })}`}
        >
          <Label classes="justify-center self-center text-white-100">{step.toString()}</Label>
        </div>
      </div>
      {renderLine(answered)}
    </>
  );
};
export default Stepper;
